module.exports = {
  "view.类型": "类型",
  "view.询价": "询价",
  "view.招标": "招标",
  "view.预计金额": "预计金额",
  "view.竞标保证金": "竞标保证金",
  "view.招标单位": "招标单位",
  "view.正文内容": "正文内容",
  "view.截止时间": "截止时间",
  "view.没有找到相关项目": "没有找到相关项目",
  "view.欢迎登录信翼通招标网": "欢迎登录信翼通招标网",
  "view.请输入账号/手机号": "请输入账号/手机号",
  "view.请输入密码": "请输入密码",
  "view.立即登录": "立即登录",
  "view.忘记密码": "忘记密码",
  "view.还没账号？": "还没账号？",
  "view.立即注册": "立即注册",
  "view.请输入": "请输入",
  "view.记住密码": "记住密码",
  "view.您好，欢迎来到信翼通招标网！": "您好，欢迎来到信翼通招标网！",
  "view.登录": "登录",
  "view.注册": "注册",
  "view.退出": "退出",
  "view.认证信息已上传，目前正在审核中，请耐心等待": "认证信息已上传，目前正在审核中，请耐心等待",
  "view.已认证": "已认证",
  "view.工作台": "工作台",
  "view.信翼通招标网": "信翼通招标网",
  "view.搜索": "搜索",
  "view.首页": "首页",
  "view.物资项目": "物资项目",
  "view.工程项目": "工程项目",
  "view.服务项目": "服务项目",
  "view.企业认证": "企业认证",
  "view.营业执照": "营业执照",
  "view.营业执照有效期": "营业执照有效期",
  "view.期限类型": "期限类型",
  "view.长期": "长期",
  "view.固定时间段": "固定时间段",
  "view.请选择开始时间": "请选择开始时间",
  "view.请选择结束时间": "请选择结束时间",
  "view.是否法人": "是否法人",
  "view.是": "是",
  "view.否": "否",
  "view.身份证(正面)": "身份证(正面)",
  "view.身份证(反面)": "身份证(反面)",
  "view.投标授权委托书": "投标授权委托书",
  "view.重新上传": "重新上传",
  "view.上传附件": "上传附件",
  "view.下载模版": "下载模版",
  "view.授权委托书有效时间": "授权委托书有效时间",
  "view.确 定": "确 定",
  "view.取 消": "取 消",
  "view.请上传营业执照": "请上传营业执照",
  "view.请选择营业执照有效期": "请选择营业执照有效期",
  "view.请选择是否法人": "请选择是否法人",
  "view.请上传身份证(正面)": "请上传身份证(正面)",
  "view.请上传身份证(反面)": "请上传身份证(反面)",
  "view.请上传投标授权委托书": "请上传投标授权委托书",
  "view.请选择授权委托书有效时间": "请选择授权委托书有效时间",
  "view.格式有误": "格式有误",
  "view.最多上传3个文件": "最多上传3个文件",
  "view.投标授权委托书模板.docx": "投标授权委托书模板.docx",
  "view.上传文件不能超过20MB": "上传文件不能超过20MB",
  "view.上传文件不能为0KB": "上传文件不能为0KB",
  "view.上传成功": "上传成功",
  "view.提交成功": "提交成功",
  "view.个人认证": "个人认证",
  "view.图片预览": "图片预览",
  "view.去认证": "去认证",
  "view.请输入项目名称": "请输入项目名称",
  "view.APP下载": "APP下载",
  "view.信翼通招标系统App": "信翼通招标系统App",
  "view.(仅限安卓版本)": "(仅限安卓版本)",
  "view.可使用微信扫一扫扫码下载": "可使用微信扫一扫扫码下载",
  "view.上传营业执照副本，仅用于资质审核": "上传营业执照副本，仅用于资质审核",
  "view.业绩": "业绩",
  "view.上传以往业绩合同附件，仅用于资质审核": "上传以往业绩合同附件，仅用于资质审核",
  "view.代理许可证": "代理许可证",
  "view.提交": "提交",
  "view.询价中": "询价中",
  "view.询价项目正在询价中，可以继续报价": "询价项目正在询价中，可以继续报价",
  "view.已弃标": "已弃标",
  "view.询价结束": "询价结束",
  "view.询价项目已结束，可以查看报价记录": "询价项目已结束，可以查看报价记录",
  "view.基本信息": "基本信息",
  "view.招标公告": "招标公告",
  "view.标的物信息": "标的物信息",
  "view.序号": "序号",
  "view.物资分类": "物资分类",
  "view.物资名称": "物资名称",
  "view.规格": "规格",
  "view.型号": "型号",
  "view.需求数量": "需求数量",
  "view.计量单位": "计量单位",
  "view.其他": "其他",
  "view.附件": "附件",
  "view.标的物附件": "标的物附件",
  "view.投标信息": "投标信息",
  "view.公司名称/姓名": "公司名称/姓名",
  "view.纳税人识别号": "纳税人识别号",
  "view.联系电话": "联系电话",
  "view.联系人": "联系人",
  "view.电子邮件地址": "电子邮件地址",
  "view.基础文件提交": "基础文件提交",
  "view.未通过原因": "未通过原因",
  "view.技术要求文件": "技术要求文件",
  "view.是否符合要求": "是否符合要求",
  "view.符合": "符合",
  "view.不符合": "不符合",
  "view.请对与技术要求文件不符处进行说明": "请对与技术要求文件不符处进行说明",
  "view.供应商技术文件": "供应商技术文件",
  "view.供应商业绩文件": "供应商业绩文件",
  "view.资质上传": "资质上传",
  "view.投标主体": "投标主体",
  "view.投标保证金": "投标保证金",
  "view.标书费": "标书费",
  "view.已缴纳": "已缴纳",
  "view.保证金": "保证金",
  "view.缴费日期": "缴费日期",
  "view.缴费凭证": "缴费凭证",
  "view.审核中": "审核中",
  "view.缴费未通过": "缴费未通过",
  "view.待缴纳": "待缴纳",
  "view.倒计时": "倒计时",
  "view.账号名称": "账号名称",
  "view.对方账户": "对方账户",
  "view.开户行": "开户行",
  "view.缴费结束时间": "缴费结束时间",
  "view.缴费方式": "缴费方式",
  "view.对公转账": "对公转账",
  "view.招标文件": "招标文件",
  "view.未提交": "未提交",
  "view.递交开始时间": "递交开始时间",
  "view.递交结束时间": "递交结束时间",
  "view.已超时": "已超时",
  "view.上传投标文件": "上传投标文件",
  "view.请点击按钮上传投标文件，可以在投标截止时问前，修改或撤回投标文件": "请点击按钮上传投标文件，可以在投标截止时问前，修改或撤回投标文件",
  "view.如果要重新上传投标文件，必须将上次上传的投标文件撤回才可重新上传": "如果要重新上传投标文件，必须将上次上传的投标文件撤回才可重新上传",
  "view.请充分考虑到传送的时间和自身的网络情况，在投标截止时间前完成投标，逾时传这会被判断为逾期送达": "请充分考虑到传送的时间和自身的网络情况，在投标截止时间前完成投标，逾时传这会被判断为逾期送达",
  "view.文件名称": "文件名称",
  "view.投标单位": "投标单位",
  "view.投标负责人": "投标负责人",
  "view.上传日期": "上传日期",
  "view.投标文件状态": "投标文件状态",
  "view.操作": "操作",
  "view.查看原因": "查看原因",
  "view.下载": "下载",
  "view.撤回投标文件": "撤回投标文件",
  "view.已上传的投标文件撤销成功后，请及时重新上传投标文件。务必保证操作历史中最新的为上传成功的记录。": "已上传的投标文件撤销成功后，请及时重新上传投标文件。务必保证操作历史中最新的为上传成功的记录。",
  "view.开标报价": "开标报价",
  "view.报价入口": "报价入口",
  "view.该投标项目已正式开标。": "该投标项目已正式开标。",
  "view.该询价项目已开始报价": "该询价项目已开始报价",
  "view.点击报价按钮，前去报价": "点击报价按钮，前去报价",
  "view.去报价": "去报价",
  "view.报价记录": "报价记录",
  "view.第": "第",
  "view.轮报价": "轮报价",
  "view.物料名称": "物料名称",
  "view.预算金额": "预算金额",
  "view.币种": "币种",
  "view.含税单价": "含税单价",
  "view.税率": "税率",
  "view.物料总价": "物料总价",
  "view.其他费用": "其他费用",
  "view.总价": "总价",
  "view.结算方式": "结算方式",
  "view.报价说明": "报价说明",
  "view.单个体积": "单个体积",
  "view.体积单位": "体积单位",
  "view.单个重量": "单个重量",
  "view.重量单位": "重量单位",
  "view.排名": "排名",
  "view.本轮最低价": "本轮最低价",
  "view.整体总价": "整体总价",
  "view.整体排名": "整体排名",
  "view.项目公示": "项目公示",
  "view.报价轮次": "报价轮次",
  "view.轮": "轮",
  "view.报价": "报价",
  "view.你方": "你方",
  "view.所递交的": "所递交的",
  "view.投标文件已被我方接受，被确定为中标人。": "投标文件已被我方接受，被确定为中标人。",
  "view.中标价": "中标价",
  "view.小写": "小写",
  "view.请你方在接到本通知书后的30日内到": "请你方在接到本通知书后的30日内到",
  "view.与我方签订": "与我方签订",
  "view.合同协议书": "合同协议书",
  "view.退还保证金": "退还保证金",
  "view.待退还保证金": "待退还保证金",
  "view.已退还保证金": "已退还保证金",
  "view.退费凭证": "退费凭证",
  "view.确认退还": "确认退还",
  "view.确认退还倒计时": "确认退还倒计时",
  "view.报价说明文件": "报价说明文件",
  "view.用于上传盖章版报价说明文件，请在最后一次报价结束后上传": "用于上传盖章版报价说明文件，请在最后一次报价结束后上传",
  "view.弃标": "弃标",
  "view.资质审核": "资质审核",
  "view.缴纳保证金": "缴纳保证金",
  "view.项目标书": "项目标书",
  "view.投标竞价": "投标竞价",
  "view.定标": "定标",
  "view.已过提交时间": "已过提交时间",
  "view.请选择是否符合要求": "请选择是否符合要求",
  "view.请上传供应商技术文件": "请上传供应商技术文件",
  "view.请上传供应商业绩文件": "请上传供应商业绩文件",
  "view.请输入原因": "请输入原因",
  "view.请在标书递交开始时间进行递交": "请在标书递交开始时间进行递交",
  "view.请完善信息": "请完善信息",
  "view.操作成功": "操作成功",
  "view.保证金是否确认收到": "保证金是否确认收到",
  "view.提示": "提示",
  "view.确定": "确定",
  "view.取消": "取消",
  "view.是否要放弃该标": "是否要放弃该标",
  "view.请上传缴费证明": "请上传缴费证明",
  "view.请上传营业执照资质": "请上传营业执照资质",
  "view.请上传业绩": "请上传业绩",
  "view.请上传代理许可": "请上传代理许可",
  "view.请上传": "请上传",
  "view.是否接受当前结算方式": "是否接受当前结算方式",
  "view.先款后货": "先款后货",
  "view.先货后款": "先货后款",
  "view.按比例支付": "按比例支付",
  "view.项目类型": "项目类型",
  "view.是否公开询价": "是否公开询价",
  "view.中标方式": "中标方式",
  "view.分项": "分项",
  "view.整体": "整体",
  "view.联系人/电话": "联系人/电话",
  "view.询价截止时间": "询价截止时间",
  "view.付款条件": "付款条件",
  "view.招标名称": "招标名称",
  "view.报名开始时间": "报名开始时间",
  "view.标书费用": "标书费用",
  "view.招标方式": "招标方式",
  "view.竞价保证金": "竞价保证金",
  "view.质保期": "质保期",
  "view.报名结束时间": "报名结束时间",
  "view.投标详情": "投标详情",
  "view.报价详情": "报价详情",
  "view.缴费": "缴费",
  "view.收起": "收起",
  "view.展开": "展开",
  "view.报价模板": "报价模板",
  "view.接受": "接受",
  "view.不接受": "不接受",
  "view.开标倒计时": "开标倒计时",
  "view.本项目开标进入倒计时阶段。请各位投标人提前做好开标相关准备，确保能准时参与开标活动。": "本项目开标进入倒计时阶段。请各位投标人提前做好开标相关准备，确保能准时参与开标活动。",
  "view.物资报价信息": "物资报价信息",
  "view.已开标": "已开标",
  "view.备注": "备注",
  "view.当前项目已开标": "当前项目已开标",
  "view.投标文件": "投标文件",
  "view.投标文件类型": "投标文件类型",
  "view.商务文件": "商务文件",
  "view.技术文件": "技术文件",
  "view.由采购部驳回，请修改后重新提交": "由采购部驳回，请修改后重新提交",
  "view.请输入招标项目/招标单位以搜索": "请输入招标项目/招标单位以搜索",
  "view.项目状态": "项目状态",
  "view.投标状态": "投标状态",
  "view.查询": "查询",
  "view.招标项目名称": "招标项目名称",
  "view.招标/询价": "招标/询价",
  "view.发布时间": "发布时间",
  "view.报名时间": "报名时间",
  "view.投标人": "投标人",
  "view.查看": "查看",
  "view.处理": "处理",
  "view.询价中/报价中": "询价中/报价中",
  "view.中标明细": "中标明细",
  "view.中标金额": "中标金额",
  "view.项目名称：": "项目名称：",
  "view.招标单位：": "招标单位：",
  "view.发布时间：": "发布时间：",
  "view.开始日期": "开始日期",
  "view.结束日期": "结束日期",
  "view.重置": "重置",
  "view.我的关注": "我的关注",
  "view.详情": "详情",
  "view.删除": "删除",
  "view.是否取消关注该项目": "是否取消关注该项目",
  "view.删除成功": "删除成功",
  "view.请输入招标项目名称以搜索": "请输入招标项目名称以搜索",
  "view.请输入单位名称名称以搜索": "请输入单位名称名称以搜索",
  "view.项目状态：": "项目状态：",
  "view.提交日期：": "提交日期：",
  "view.提交人：": "提交人：",
  "view.我的问题": "我的问题",
  "view.新增": "新增",
  "view.单位名称": "单位名称",
  "view.提交时间": "提交时间",
  "view.提交人": "提交人",
  "view.提交人联系电话": "提交人联系电话",
  "view.状态": "状态",
  "view.草稿": "草稿",
  "view.提交未回复": "提交未回复",
  "view.已回复": "已回复",
  "view.是否删除该信息?": "是否删除该信息?",
  "view.是否提交该信息?": "是否提交该信息?",
  "view.问题详情": "问题详情",
  "view.请输入关键词": "请输入关键词",
  "view.提问单位名称": "提问单位名称",
  "view.问题描述": "问题描述",
  "view.提 交": "提 交",
  "view.保 存": "保 存",
  "view.问题回复": "问题回复",
  "view.问题回复情况": "问题回复情况",
  "view.问题回复人": "问题回复人",
  "view.回复时间": "回复时间",
  "view.个人信息": "个人信息",
  "view.姓名": "姓名",
  "view.登录账号": "登录账号",
  "view.纳税人识别号(身份证号)": "纳税人识别号(身份证号)",
  "view.电子邮箱": "电子邮箱",
  "view.保存": "保存",
  "view.保存成功": "保存成功",
  "view.个人中心": "个人中心",
  "view.我的投标": "我的投标",
  "view.密码修改": "密码修改",
  "view.处理事项": "处理事项",
  "view.旧密码": "旧密码",
  "view.新密码": "新密码",
  "view.确认密码": "确认密码",
  "view.密码不一致": "密码不一致",
  "view.修改成功": "修改成功",
  "view.是否提交投标文件": "是否提交投标文件",
  "view.支付比例": "支付比例",
  "view.本轮报价": "本轮报价",
  "view.下载模板": "下载模板",
  "view.导入": "导入",
  "view.每轮次单价降价幅度比上一轮单价低": "每轮次单价降价幅度比上一轮单价低",
  "view.元": "元",
  "view.预付款": "预付款",
  "view.发货款": "发货款",
  "view.到货款": "到货款",
  "view.到货检验款": "到货检验款",
  "view.设备安装费": "设备安装费",
  "view.项目检验费用": "项目检验费用",
  "view.质保": "质保",
  "view.单价": "单价",
  "view.请完善": "请完善",
  "view.信息": "信息",
  "view.导入中": "导入中",
  "view.导入成功": "导入成功",
  "view.操作失败": "操作失败",
  "view.询价单位": "询价单位",
  "view.商务联系人/电话": "商务联系人/电话",
  "view.分项中标": "分项中标",
  "view.整体中标": "整体中标",
  "view.投标方式": "投标方式",
  "view.现场招标": "现场招标",
  "view.线上招标": "线上招标",
  "view.技术联系人/电话": "技术联系人/电话",
  "view.开标时间": "开标时间",
  "view.整体排名：当前排名第": "整体排名：当前排名第",
  "view.财务成本价": "财务成本价",
  "view.当前最低价": "当前最低价",
  "view.当前最高价": "当前最高价",
  "view.距离报价结束：": "距离报价结束：",
  "view.上一轮": "上一轮",
  "view.每轮次报价降价幅度比上一轮报价低": "每轮次报价降价幅度比上一轮报价低",
  "view.每轮次报价上涨幅度比上一轮报价高": "每轮次报价上涨幅度比上一轮报价高",
  "view.每轮次报价降价幅度比全场最低价低": "每轮次报价降价幅度比全场最低价低",
  "view.每轮次报价上涨幅度比全场最高价高": "每轮次报价上涨幅度比全场最高价高",
  "view.技术附件": "技术附件",
  "view.项目总预算：": "项目总预算：",
  "view.预算总价": "预算总价",
  "view.预算单价": "预算单价",
  "view.是否含税": "是否含税",
  "view.标段信息": "标段信息",
  "view.报价（含税）": "报价（含税）",
  "view.系数": "系数",
  "view.总价（含税）": "总价（含税）",
  "view.请确认": "请确认",
  "view.真实报价是否为0，若不对该标的物进行报价，则空置不填": "真实报价是否为0，若不对该标的物进行报价，则空置不填",
  "view.标段": "标段",
  "view.数量": "数量",
  "view.报价方式": "报价方式",
  "view.限价": "限价",
  "view.系数名称": "系数名称",
  "view.币种单位": "币种单位",
  "view.询价要求文件": "询价要求文件",
  "view.标的物附件：": "标的物附件：",
  "view.已关注": "已关注",
  "view.关注": "关注",
  "view.参与询价": "参与询价",
  "view.报名成功": "报名成功",
  "view.关注成功": "关注成功",
  "view.无": "无",
  "view.期望到货日期": "期望到货日期",
  "view.标段名称": "标段名称",
  "view.取消关注成功": "取消关注成功",
  "view.建设单位": "建设单位",
  "view.收费信息": "收费信息",
  "view.金额": "金额",
  "view.账号": "账号",
  "view.投标人资质要求": "投标人资质要求",
  "view.报名": "报名",
  "view.返回首页": "返回首页",
  "view.密码重置": "密码重置",
  "view.进行身份验证": "进行身份验证",
  "view.重新设置密码": "重新设置密码",
  "view.完成密码重置": "完成密码重置",
  "view.邮箱地址": "邮箱地址",
  "view.图形验证": "图形验证",
  "view.请计算得出验证码结果": "请计算得出验证码结果",
  "view.邮箱验证": "邮箱验证",
  "view.请输入邮箱收到的验证码": "请输入邮箱收到的验证码",
  "view.重置密码": "重置密码",
  "view.请输入再次输入新密码": "请输入再次输入新密码",
  "view.修改": "修改",
  "view.密码重置成功": "密码重置成功",
  "view.您的密码已重置成功，请牢记新密码！": "您的密码已重置成功，请牢记新密码！",
  "view.已有账号？": "已有账号？",
  "view.去登录": "去登录",
  "view.两次输入的密码不一致": "两次输入的密码不一致",
  "view.邮箱格式有误": "邮箱格式有误",
  "view.手机号码不能为空": "手机号码不能为空",
  "view.请输入正确的手机号码": "请输入正确的手机号码",
  "view.密码强度不够(数字、大小写、特殊字符组成)": "密码强度不够(数字、大小写、特殊字符组成)",
  "view.获取验证码": "获取验证码",
  "view.请选择": "请选择",
  "view.请输入您的密码": "请输入您的密码",
  "view.用户密码长度必须介于 5 和 20 之间": "用户密码长度必须介于 5 和 20 之间",
  "view.短信验证": "短信验证",
  "view.手机号码": "手机号码",
  "view.请输入短信收到的验证码": "请输入短信收到的验证码",
  "view.招询公告": "招询公告",
  "view.招标项目": "招标项目",
  "view.更多": "更多",
  "view.预计金额：": "预计金额：",
  "view.询价项目": "询价项目",
  "view.欢迎注册信翼通招标网": "欢迎注册信翼通招标网",
  "view.单位注册": "单位注册",
  "view.个人注册": "个人注册",
  "view.企业名称": "企业名称",
  "view.密码": "密码",
  "view.身份证": "身份证",
  "view.邮箱": "邮箱",
  "view.邮箱验证码": "邮箱验证码",
  "view.主营业务": "主营业务",
  "view.为了更精确投标业务，请填写主营业务": "为了更精确投标业务，请填写主营业务",
  "view.我已阅读并同意": "我已阅读并同意",
  "view.《招标网平台会员注册须知》": "《招标网平台会员注册须知》",
  "view.《招标网平台法律声明》": "《招标网平台法律声明》",
  "view.手机号格式有误": "手机号格式有误",
  "view.请勾选注册须知": "请勾选注册须知",
  "view.注册成功": "注册成功",
  "view.填写企业信息": "填写企业信息",
  "view.信息审核中": "信息审核中",
  "view.身份认证通过": "身份认证通过",
  "view.公司信息": "公司信息",
  "view.供应商名称": "供应商名称",
  "view.供应商简称": "供应商简称",
  "view.供应商地址": "供应商地址",
  "view.供应商类别": "供应商类别",
  "view.企业类型": "企业类型",
  "view.生产地址": "生产地址",
  "view.生产规模/产能（台套）": "生产规模/产能（台套）",
  "view.代理商资质": "代理商资质",
  "view.产品生产资质": "产品生产资质",
  "view.纳税性质": "纳税性质",
  "view.实缴资本": "实缴资本",
  "view.注册地址": "注册地址",
  "view.注册资金": "注册资金",
  "view.职工人数": "职工人数",
  "view.厂房面积": "厂房面积",
  "view.年营业额": "年营业额",
  "view.公司成立日期": "公司成立日期",
  "view.三年财报": "三年财报",
  "view.经营范围": "经营范围",
  "view.供应产品名称(产品类别、主营产品)": "供应产品名称(产品类别、主营产品)",
  "view.产品出厂检测标准": "产品出厂检测标准",
  "view.是否经我司试用": "是否经我司试用",
  "view.供货产品信息": "供货产品信息",
  "view.供应产品名称": "供应产品名称",
  "view.产品是否经过我司试用": "产品是否经过我司试用",
  "view.请添加供货产品信息": "请添加供货产品信息",
  "view.请输入产品": "请输入产品",
  "view.营业信息": "营业信息",
  "view.法定代表人": "法定代表人",
  "view.法人代表身份证明": "法人代表身份证明",
  "view.下载样例": "下载样例",
  "view.至": "至",
  "view.点击上传": "点击上传",
  "view.文件地址不存在": "文件地址不存在",
  "view.该格式不支持在线预览，已下载文件": "该格式不支持在线预览，已下载文件",
  "view.投标人信息": "投标人信息",
  "view.联系方式": "联系方式",
  "view.委托书有效期 ": "委托书有效期 ",
  "view.开户信息": "开户信息",
  "view.银行账号": "银行账号",
  "view.开户银行": "开户银行",
  "view.是否进行企业认证": "是否进行企业认证",
  "view.护照": "护照",
  "view.法人代表身份证明（正面）": "法人代表身份证明（正面）",
  "view.法人代表身份证明（反面）": "法人代表身份证明（反面）",
  "view.大于当前系统时间": "大于当前系统时间",
  "view.开始时间不得大于结束时间": "开始时间不得大于结束时间",
  "view.填写个人信息": "填写个人信息",
  "view.下一步": "下一步",
  "view.上一步": "上一步",
  "view.信息反馈": "信息反馈",
  "view.请在企业信息内完善法人身份证信息": "请在企业信息内完善法人身份证信息",
  "view.开户行号": "开户行号",
  "view.供货类型及品牌": "供货类型及品牌",
  "view.添加": "添加",
  "view.供货类型": "供货类型",
  "view.品牌": "品牌",
  "view.业务联系人": "业务联系人",
  "view.人员类型": "人员类型",
  "view.请选择人员类型": "请选择人员类型",
  "view.请添加业务联系人": "请添加业务联系人",
  "view.电话": "电话",
  "view.单位管理人": "单位管理人",
  "view.合同签订人": "合同签订人",
  "view.采购业务员": "采购业务员",
  "view.请添加供货类型及品牌信息": "请添加供货类型及品牌信息",
  "view.招标联系人": "招标联系人",
  "view.选择人员": "选择人员",
  "view.选择招标联系人": "选择招标联系人",
  "view.正常": "正常",
  "view.停用": "停用",
  "view.上传失败": "上传失败",
  "view.审批驳回": "审批驳回",
  "view.审批中": "审批中",
  "view.审核通过": "审核通过",
  "view.物资编码": "物资编码",
  "view.来源": "来源",
  "view.合同名称/招标项目": "合同名称/招标项目",
  "view.商品信息": "商品信息",
  "view.采购/招标负责人": "采购/招标负责人",
  "view.驳回原因": "驳回原因",
  "view.完善信息": "完善信息",
  "view.物资名称-信息填写": "物资名称-信息填写",
  "view.是否进口": "是否进口",
  "view.商品介绍": "商品介绍",
  "view.商品主图(包含图片、3D建模、视频等)": "商品主图(包含图片、3D建模、视频等)",
  "view.批量提交": "批量提交",
  "view.请选择要提交的数据": "请选择要提交的数据",
  "view.物资名称-信息查看": "物资名称-信息查看",
  "view.查看信息": "查看信息",
  "view.选择物资": "选择物资",
  "view.供应商": "供应商",
  "view.请输入物资编码": "请输入物资编码",
  "view.请输入物资名称": "请输入物资名称",
  "view.请输入规格": "请输入规格",
  "view.请输入型号": "请输入型号",
  "view.请选择一条物资信息": "请选择一条物资信息",
  "view.模板.xlsx": "模板.xlsx",
  "view.业绩文件": "业绩文件",
  "view.代理许可": "代理许可",
  "view.报价文件": "报价文件",
  "view.投标项目": "投标项目",
  "view.驳回信息": "驳回信息",
  "view.信息审核驳回": "信息审核驳回",
  "view.物资/项目": "物资/项目",
  "view.完善价格": "完善价格",
  "view.企业类别": "企业类别",
  "view.国内供应商": "国内供应商",
  "view.印尼供应商": "印尼供应商",
  "view.转为印尼供应商": "转为印尼供应商",
  "view.转为国内供应商": "转为国内供应商",
  "view.企业信息": "企业信息",
  "view.是否转为国内供应商": "是否转为国内供应商",
  "view.备件信息完善": "备件信息完善",
  "view.招标项目/招标单位": "招标项目/招标单位",
  "view.招标负责人": "招标负责人",
  "view.备件信息完善详情": "备件信息完善详情",
  "view.物资信息": "物资信息",
  "view.备件信息": "备件信息",
  "view.备件名称": "备件名称",
  "view.更换周期": "更换周期",
  "view.主图": "主图",
  "view.请添加备件信息": "请添加备件信息",
  "view.投标授权委托书过期提醒": "投标授权委托书过期提醒",
  "view.注：距离投标授权委托书过期还有": "注：距离投标授权委托书过期还有",
  "view.天": "天",
  "view.请尽快重新上传": "请尽快重新上传",
  "view.投标授权委托书已过期，请尽快重新上传": "投标授权委托书已过期，请尽快重新上传",
  "view.授权委托书管理": "授权委托书管理",
  "view.审批通过时间": "审批通过时间",
  "view.变更授权委托书": "变更授权委托书",
  "view.授权委托书已上传，目前正在审核中，请耐心等待": "授权委托书已上传，目前正在审核中，请耐心等待",
  "view.请输入本人真实姓名": "请输入本人真实姓名",
  "view.您的问题已提交，运营人员将会与您联系": "您的问题已提交，运营人员将会与您联系",
  "view.返回": "返回",
  "view.变更供货类型": "变更供货类型",
  "view.项目信息": "项目信息",
  "view.变更申请记录": "变更申请记录",
  "view.项目名称": "项目名称",
  "view.提交日期": "提交日期",
  "view.处理人": "处理人",
  "view.处理时间": "处理时间",
  "view.贵单位供货类型信息与当前项目物资分类": "贵单位供货类型信息与当前项目物资分类",
  "view.不符，请确认是否符合招标要求并继续报名。": "不符，请确认是否符合招标要求并继续报名。",
  "view.检测到贵企业有正在审批的企业信息变更申请，请等待变更流程审批完成、企业信息更新生效后，再重新提交报名。": "检测到贵企业有正在审批的企业信息变更申请，请等待变更流程审批完成、企业信息更新生效后，再重新提交报名。",
  "view.物料编码": "物料编码",
  "view.价格类型":'价格类型',
  "view.报名状态":'报名状态',
  "view.待完善价格":'待完善价格',
  "view.待审核":'待审核',
  "view.报名失败":'报名失败',
  "view.价格审批驳回":'价格审批驳回',
  "view.价格审批中":'价格审批中',
  "view.选择":'选择',
}